import { useAccordionControl } from 'components/accordion/useAccordionControl'
import { resolveName } from 'components/form/final-form/hooks/useField'
import { TipoAtendimentoEnum } from 'graphql/types.generated'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import React, { useState } from 'react'
import { useField } from 'react-final-form'
import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays'
import { MetaPath, metaPath } from 'util/metaPath'
import { SoapState } from 'view/atendimentos/atendimento-individual/model'
import { AtendimentoProfissional } from 'view/atendimentos/types/AtendimentoProfissionalModel'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import HeadingFormControl from '../components/HeadingFormControl'
import { OrientacoesCadastroView } from './list/OrientacoesCadastroView'
import { OrientacoesTable } from './list/OrientacoesTable'
import { OrientacaoFormModel } from './types/model-oriendacoes'

interface OrientacoesViewProps {
  name: MetaPath<OrientacaoFormModel>
  prontuarioId: ID
  atendimentoId: ID
  cidadao: CidadaoAtendimento
  orientacoes: OrientacaoFormModel[]
  atendimentoProfissional: AtendimentoProfissional
}

const metaSoap = metaPath<SoapState>()

export function OrientacoesView(props: OrientacoesViewProps) {
  const { name, prontuarioId, atendimentoId, orientacoes, atendimentoProfissional, cidadao } = props

  const [idOrientacaoEmEdicao, setIdOrientacaoEmEdicao] = useState<ID>()

  const { resetExpandedItems, ...accordionProps } = useAccordionControl({})

  const {
    observacao: { isAtendimentoObservacao },
    isRetificacao,
  } = useAtendimentoContext()

  const {
    input: { value: tipoAtendimentoValue },
  } = useField<TipoAtendimentoEnum>(resolveName(metaSoap.finalizacao.tipoAtendimento), {
    subscription: { value: true },
  })

  const renderFieldArray = (fieldArrayRenderProps: FieldArrayRenderProps<OrientacaoFormModel, any>) => {
    const {
      fields: { push, update, remove },
    } = fieldArrayRenderProps

    const handleSubmit = (value: OrientacaoFormModel) => {
      push(value)
      resetExpandedItems()
    }

    const handleRemove = (index: number) => {
      remove(index)
      resetExpandedItems()
    }

    return (
      <>
        <OrientacoesCadastroView onSubmit={handleSubmit} onFocus={() => setIdOrientacaoEmEdicao(null)} />
        <OrientacoesTable
          cidadao={cidadao}
          atendimentoId={atendimentoId}
          prontuarioId={prontuarioId}
          orientacoes={orientacoes}
          atendimentoProfissionalId={atendimentoProfissional.id}
          tipoAtendimento={tipoAtendimentoValue}
          localAtendimento={atendimentoProfissional.atendimento.localAtendimento}
          isAtendimentoObservacao={isAtendimentoObservacao}
          dataReferencia={atendimentoProfissional.iniciadoEm}
          lotacao={atendimentoProfissional.lotacao}
          idOrientacaoEmEdicao={idOrientacaoEmEdicao}
          update={update}
          remove={handleRemove}
          onEditClick={setIdOrientacaoEmEdicao}
          resetExpandedItems={resetExpandedItems}
          isRetificacao={isRetificacao}
          {...accordionProps}
        />
      </>
    )
  }

  return (
    <>
      <HeadingFormControl label='Orientações ao cidadão' required level='h4' />
      <FieldArray name={resolveName(name)} render={renderFieldArray} />
    </>
  )
}
